import useLsaChargeName from '../../hooks/useLsaChargeName'

const BADGE = 'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold whitespace-nowrap'

const ChargeNameBadge = ({ userId }) => {
  const { required, pick, ofRecord } = useLsaChargeName(userId)

  if (ofRecord) {
    return (
      <span className={`${BADGE} bg-success-light text-success-main`}>
        {`Charge as: ${ofRecord.label}`}
      </span>
    )
  }

  if (required && pick && !pick.signed) {
    return (
      <span className={`${BADGE} bg-warning-light text-warning-main`}>
        {`${pick.label} picked, not signed yet`}
      </span>
    )
  }

  return null
}

export default ChargeNameBadge
